export default __webpack_public_path__ + "static/media/store.a8753ab0.png";